<template>
  <p v-if="!bukaDetail" class="align-center">表示できる内容がありません</p>
  <div class="container syuugyou-basyo-list" v-else>
    <div class="syuugyou-basyo-editor" v-if="isInsertMode && syuugyouBasyoEditObj">
      <h3>就業場所の新規追加</h3>
      <div class="form">
        <div class="item kana">
          <b class="required">就業場所名</b>
          <input-text type="text" v-model="syuugyouBasyoEditObj.syuugyou_basyo_name"
            :error="getError(syuugyouBasyoEditObj, 'syuugyou_basyo_name')"></input-text>
        </div>
        <div class="item kana">
          <b class="required">就業場所名（カナ）</b>
          <input-text type="text" v-model="syuugyouBasyoEditObj.syuugyou_basyo_kana"
            :error="getError(syuugyouBasyoEditObj, 'syuugyou_basyo_kana')"></input-text>
        </div>
        <div class="item kana">
          <b class="required">所在地</b>
          <input-text type="text" v-model="syuugyouBasyoEditObj.syuugyou_basyo_address"
            :error="getError(syuugyouBasyoEditObj, 'syuugyou_basyo_address')"></input-text>
        </div>
        <div class="item kana">
          <b class="required">電話番号</b>
          <input-text type="text" v-model="syuugyouBasyoEditObj.syuugyou_basyo_tel"
            :error="getError(syuugyouBasyoEditObj, 'syuugyou_basyo_tel')"></input-text>
        </div>
      </div>
    </div>

    <div class="buttons" v-if="!isInsertMode">
      <button type="button" :class="{ disabled: isEditMode }" :disabled="isEditMode" class="btn primary"
        @click="startInsertMode">
        <i class="fa-solid fa-plus"></i>新規作成
      </button>
    </div>

    <div class="buttons" v-else-if="isInsertMode">
      <button type="button" :class="{ disabled: isEditMode }" :disabled="isEditMode" class="btn warning"
        @click="endInsertMode">
        <i class="fa-solid"></i>キャンセル
      </button>
      <button type="button" :class="{ disabled: isEditMode }" :disabled="isEditMode" class="btn success"
        @click="saveSyuugyouBasyo">
        <i class="fa-solid fa-angles-down"></i>追加
      </button>
    </div>

    <section class="table-wrapper">
      <p class="aligncenter" v-if="bukaDetail.syuugyou_basyos.length < 1">就業場所が設定されていません</p>
      <table class="list-table" v-else>
        <thead>
          <tr>
            <th>[就業場所ID] 就業場所名<br>（カナ）</th>
            <th>所在地</th>
            <th>電話番号</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(syuugyouBasyo, index) in bukaDetail.syuugyou_basyos">
            <td class="syuugyou-basyo name">
              <template v-if="isEditMode && editTargetIndex === index && syuugyouBasyoEditObj">
                <input-text type="text" v-model="syuugyouBasyoEditObj.syuugyou_basyo_name"
                  :error="getError(syuugyouBasyoEditObj, 'syuugyou_basyo_name')"></input-text>
                <input-text type="text" v-model="syuugyouBasyoEditObj.syuugyou_basyo_kana"
                  :error="getError(syuugyouBasyoEditObj, 'syuugyou_basyo_kana')"></input-text>
              </template>

              <template v-else>
                [{{ syuugyouBasyo.mst_syuugyou_basyo_id }}] {{ syuugyouBasyo.syuugyou_basyo_name }}<br>
                <template v-if="syuugyouBasyo.syuugyou_basyo_kana">（{{ syuugyouBasyo.syuugyou_basyo_kana
                  }}）</template>
              </template>
            </td>
            <td class="syuugyou-basyo address">
              <template v-if="isEditMode && editTargetIndex === index && syuugyouBasyoEditObj">
                <input-text type="text" v-model="syuugyouBasyoEditObj.syuugyou_basyo_address"
                  :error="getError(syuugyouBasyoEditObj, 'syuugyou_basyo_address')"></input-text></template>

              <template v-else>{{ syuugyouBasyo.syuugyou_basyo_address }}</template>
            </td>
            <td class="syuugyou-basyo tel">
              <template v-if="isEditMode && editTargetIndex === index && syuugyouBasyoEditObj">
                <input-text type="text" v-model="syuugyouBasyoEditObj.syuugyou_basyo_tel"
                  :error="getError(syuugyouBasyoEditObj, 'syuugyou_basyo_tel')"></input-text></template>

              <template v-else>{{ syuugyouBasyo.syuugyou_basyo_tel }}</template>

            </td>
            <td class="syuugyou-basyo control">
              <div class="flex">
                <button v-if="!isEditMode" type="button" class="btn danger" :class="{ disabled: isInsertMode }"
                  :disabled="isInsertMode" v-on:click="deleteSyuugyouBasyoConfirm(syuugyouBasyo.mst_syuugyou_basyo_id!)"><i
                    class="fa-solid fa-trash btn-edit"></i>削除</button>
                <button v-if="!isEditMode" type="button" class="btn primary" :class="{ disabled: isInsertMode }"
                  :disabled="isInsertMode" v-on:click="startEditMode(syuugyouBasyo, index)"><i
                    class="fa-solid fa-pen btn-edit"></i>編集</button>

                <button v-if="isEditMode && editTargetIndex === index" type="button" class="btn success" v-on:click="saveSyuugyouBasyo()">保存</button>
                <button v-if="isEditMode && editTargetIndex === index" type="button" class="btn warning" v-on:click="endEditMode()">キャンセル</button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  </div>
</template>

<script lang="ts">

import { defineComponent, onMounted, Ref, ref } from 'vue'
import { RouterConst } from '@/const/Router'
import { useBukaDetail } from '@/composable/master/buka/buka';
import { useAuthStore } from '@/store/auth';
import { useRoute } from 'vue-router';
import { Logger } from '@/utils/Logger';
import { DialogService } from '@/service/DialogService';
import { useSyuugyouBasyoEdit } from '@/composable/master/buka/syuugyou-basyo-edit';
import { useForm } from '@/composable/form/form';
import { SyuugyouBasyo } from '@/types/KoyouKeiyaku';
import { cloneDeep } from 'lodash';

export default defineComponent({
  setup(props, context) {
    const { getBukaDetail, bukaDetail } = useBukaDetail()
    const { syuugyouBasyoEditObj, initSyuugyouBasyoEditObj, deleteSyuugyouBasyoEditObj, upsertSyuugyouBasyo, deleteSyuugyouBasyo } = useSyuugyouBasyoEdit()
    const authStore = useAuthStore()

    const isLoading = ref(false)
    const isSaving = ref(false)
    const isInsertMode = ref(false)
    const isEditMode = ref(false)
    const editTargetIndex: Ref<number | null> = ref(null)

    const { getError } = useForm()
    const route = useRoute()
    const bukaId: Ref<number | null> = ref(null)

    onMounted(async () => {
      bukaId.value = parseInt(route.params.bukaId as string, 10)
      if (!bukaId.value) {
        await DialogService.error({
          html: '部課IDの取得に失敗しました。<br>一覧画面から開き直して下さい。'
        })
        return
      }
      await load()
    })

    const load = async () => {
      isLoading.value = true
      isEditMode.value = false
      isInsertMode.value = false
      editTargetIndex.value = null
      await deleteSyuugyouBasyoEditObj()

      await getBukaDetail(bukaId.value!) // 部課IDの有無はonMountedで判定しているので!で問題ない
      isLoading.value = false
    }

    const saveSyuugyouBasyo = async () => {
      const dialogResult = await DialogService.question({
        html: '保存しますか？',
        showCancelButton: true,
        confirmButtonText: '保存する',
        cancelButtonText: 'キャンセル',
      })

      if (!dialogResult.isConfirmed) {
        return
      }

      isSaving.value = true
      try {
        const res = await upsertSyuugyouBasyo(syuugyouBasyoEditObj)

        if (res.result) {
          await load()
        }
      } catch {
      } finally {
        isSaving.value = false
        Logger.debug('finally')
      }
    }

    const startInsertMode = async () => {
      if (!bukaDetail.value) return
      isInsertMode.value = true
      initSyuugyouBasyoEditObj(bukaDetail.value)
    }

    const confirmCancel = async () => {
      return await DialogService.warning({
        html: '編集をキャンセルしますか？<br>キャンセルすると入力済みの内容は破棄されます。',
        showCancelButton: true,
        confirmButtonText: 'キャンセルする',
        cancelButtonText: '編集を続ける',
      })
    }

    const endInsertMode = async () => {
      if (!(await confirmCancel()).isConfirmed) return

      await deleteSyuugyouBasyoEditObj()
      isInsertMode.value = false
    }

    const startEditMode = async (syuugyouBasyo: SyuugyouBasyo, index: number) => {
      isEditMode.value = true
      syuugyouBasyoEditObj.value = cloneDeep(syuugyouBasyo)
      editTargetIndex.value = index
    }

    const endEditMode = async () => {
      if (!(await confirmCancel()).isConfirmed) return
      isEditMode.value = false
      editTargetIndex.value = null
      syuugyouBasyoEditObj.value = null
    }

    const deleteSyuugyouBasyoConfirm = async (syuugyouBasyoId: number) => {
      const dialogResult = await DialogService.warning({
        html: '就業場所を削除しますか？<br>なお、すでに雇用契約に紐づいている場合は削除できません。',
        showCancelButton: true,
        confirmButtonText: '削除する',
        cancelButtonText: 'キャンセル',
      })

      if (!dialogResult.isConfirmed) return

      if(await deleteSyuugyouBasyo(syuugyouBasyoId)){
        await load()
      }
    }

    return {
      isLoading,
      isInsertMode,
      isEditMode,
      editTargetIndex,
      RouterConst,
      bukaDetail,
      syuugyouBasyoEditObj,
      startInsertMode,
      endInsertMode,
      saveSyuugyouBasyo,
      startEditMode,
      endEditMode,
      deleteSyuugyouBasyoConfirm,
      getError,

    }
  },
  components: {
  }
})
</script>

<style lang="scss" scoped>
@import "@scss/components/syuugyou-basyo-edit";
</style>
